// removed by extract-text-webpack-plugin
module.exports = {"tagSelect":"antd-pro-tag-select-tagSelect","expanded":"antd-pro-tag-select-expanded","trigger":"antd-pro-tag-select-trigger","hasExpandTag":"antd-pro-tag-select-hasExpandTag"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/src/components/TagSelect/index.less
// module id = 1350
// module chunks = 0